
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendar",
      function () {
        return require("private-next-pages/calendar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendar"])
      });
    }
  